import { InputAdornment } from '@mui/material';
import { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Handler from '../../../../Handler';
import { FormInput } from '../../../../components/form/FormInput';
import MultipleFileUploader from '../../../../components/form/MultipleFileUploader';
import { projectFormValidations } from '../form';

export const CarbonEstimateInfo = (props) => {
  const { register, errors, watch, setValue, control } = props;
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === 'en';
  const validations = projectFormValidations(isEn);

  const { reductionBase, reductionBusiness, reductionLeak } = watch();

  useEffect(() => {
    if (
      Number.isFinite(Number(reductionBase)) &&
      Number.isFinite(Number(reductionBusiness)) &&
      Number.isFinite(Number(reductionLeak))
    ) {
      setValue('reduction', Number(reductionBase) - Number(reductionBusiness) - Number(reductionLeak), 'reduction');
    } else {
      setValue('reduction', '');
    }
  }, [reductionBase, reductionBusiness, reductionLeak]);

  return (
    <article className='flex flex-col gap-4 w-[945px] mb-4 py-8'>
      <article className='flex flex-col gap-4 w-[945px] mb-4 pb-8'>
        <header>
          <h2>{t('GHG_REDUCTION')}</h2>
        </header>
        <div className='grid grid-cols-2 gap-4'>
          <Controller
            control={control}
            name='reductionBase'
            rules={{
              required: validations.reductionBase.required,
              validate: validations.reductionBase.validate,
            }}
            render={({ field }) => {
              const displayValue = field.value ? Handler.numberWithCommas(field.value) : '';
              return (
                <FormInput
                  label={t('BASELINE_EMISSION')}
                  required
                  error={errors.reductionBase}
                  value={displayValue}
                  inputProps={{
                    inputMode: 'numeric',
                    ...Handler.createCommaNumberInputHandlers(field.onChange),
                  }}
                  endAdornment={<InputAdornment position='end'>tCO2-eq / year</InputAdornment>}
                />
              );
            }}
          />
          <Controller
            control={control}
            name='reductionBusiness'
            rules={{
              required: validations.reductionBusiness.required,
              validate: validations.reductionBusiness.validate,
            }}
            render={({ field }) => {
              const displayValue = field.value ? Handler.numberWithCommas(field.value) : '';
              return (
                <FormInput
                  label={t('BIZ_EMISSION')}
                  required
                  error={errors.reductionBusiness}
                  value={displayValue}
                  inputProps={{
                    inputMode: 'numeric',
                    ...Handler.createCommaNumberInputHandlers(field.onChange),
                  }}
                  endAdornment={<InputAdornment position='end'>tCO2-eq / year</InputAdornment>}
                />
              );
            }}
          />
        </div>
        <div className='grid grid-cols-2 gap-4'>
          <Controller
            control={control}
            name='reductionLeak'
            rules={{
              required: validations.reductionLeak.required,
              validate: validations.reductionLeak.validate,
            }}
            render={({ field }) => {
              const displayValue = field.value ? Handler.numberWithCommas(field.value) : '';
              return (
                <FormInput
                  label={t('LEAKAGE')}
                  required
                  error={errors.reductionLeak}
                  value={displayValue}
                  inputProps={{
                    inputMode: 'numeric',
                    ...Handler.createCommaNumberInputHandlers(field.onChange),
                  }}
                  endAdornment={<InputAdornment position='end'>tCO2-eq / year</InputAdornment>}
                />
              );
            }}
          />
          <Controller
            control={control}
            name='reduction'
            render={({ field }) => {
              const displayValue = field.value ? Handler.numberWithCommas(field.value) : '';
              return (
                <FormInput
                  label={t('GHG_REDUCTION_QUANTITY')}
                  required
                  error={errors.reduction}
                  value={displayValue}
                  disabled={true}
                  inputProps={{
                    inputMode: 'numeric',
                    disabled: true,
                    ...Handler.createCommaNumberInputHandlers(field.onChange),
                  }}
                  endAdornment={<InputAdornment position='end'>tCO2-eq / year</InputAdornment>}
                />
              );
            }}
          />
        </div>
      </article>
      <article className='flex flex-col gap-4 w-[945px] mb-4 pb-8'>
        <header>
          <h2>{t('BEFORE_AFTER_IMAGE')}</h2>
        </header>
        <div className='flex flex-col gap-4'>
          <MultipleFileUploader
            control={control}
            name='beforeImages'
            label={t('BEFORE_BIZ_IMAGE')}
            path='project/editor'
            fileType='image'
            max={10}
            error={errors.beforeImages}
            rules={{
              required: isEn ? 'Please upload the before images.' : '이전 이미지를 업로드해주세요.',
            }}
            required
          />
          <MultipleFileUploader
            control={control}
            name='afterImages'
            label={t('AFTER_BIZ_IMAGE')}
            path='project/editor'
            fileType='image'
            max={10}
            error={errors.afterImages}
            rules={{
              required: isEn ? 'Please upload the after images.' : '이후 이미지를 업로드해주세요.',
            }}
            required
          />
        </div>
      </article>
    </article>
  );
};
